 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import E9781460359662_FM001 from '@/components/e9781460359662_fm001'
 import E9781460359662_FM002 from '@/components/e9781460359662_fm002'
 import E9781460359662_TITLE001 from '@/components/e9781460359662_title001'
 import E9781460359662_FM003 from '@/components/e9781460359662_fm003'
 import E9781460359662_FM004 from '@/components/e9781460359662_fm004'
 import E9781460359662_TOC001 from '@/components/e9781460359662_toc001'
 import E9781460359662_CH001 from '@/components/e9781460359662_ch001'
 import E9781460359662_CH002 from '@/components/e9781460359662_ch002'
 import E9781460359662_CH003 from '@/components/e9781460359662_ch003'
 import E9781460359662_CH004 from '@/components/e9781460359662_ch004'
 import E9781460359662_CH005 from '@/components/e9781460359662_ch005'
 import E9781460359662_CH006 from '@/components/e9781460359662_ch006'
 import E9781460359662_CH007 from '@/components/e9781460359662_ch007'
 import E9781460359662_CH008 from '@/components/e9781460359662_ch008'
 import E9781460359662_CH009 from '@/components/e9781460359662_ch009'
 import E9781460359662_CH010 from '@/components/e9781460359662_ch010'
 import E9781460359662_CH011 from '@/components/e9781460359662_ch011'
 import E9781460359662_CH012 from '@/components/e9781460359662_ch012'
 import E9781460359662_CH013 from '@/components/e9781460359662_ch013'
 import E9781460359662_CH014 from '@/components/e9781460359662_ch014'
 import E9781460359662_CH015 from '@/components/e9781460359662_ch015'
 import E9781460359662_CH016 from '@/components/e9781460359662_ch016'
 import E9781460359662_BM001 from '@/components/e9781460359662_bm001'
 import E9781460359662_COPY001 from '@/components/e9781460359662_copy001'
 import E9781460359662_FOOTNOTE from '@/components/e9781460359662_footnote'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/e9781460359662_toc001",
 			"name" : "e9781460359662_toc001",
 			"component" : E9781460359662_TOC001
 		},
 		{
 			"path" : "/e9781460359662_ch001",
 			"name" : "e9781460359662_ch001",
 			"component" : E9781460359662_CH001
 		},
 		{
 			"path" : "/e9781460359662_ch002",
 			"name" : "e9781460359662_ch002",
 			"component" : E9781460359662_CH002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js